import { Pipe, PipeTransform } from '@angular/core';

import { ISalesOrderItem } from '../../order/interfaces/order-transfer.interface';

@Pipe({
  name: 'orderItemsAgTable',
})
export class OrderItemsAgTablePipe implements PipeTransform {
  transform(item :ISalesOrderItem) :string {
    return 'null';
  }
}
